import gqlRequest from 'graphql/generic';

/**
 * Set a single user preference by key.
 *
 * IMPORTANT — opaque string handling:
 * The backend stores all preferences as plain strings (GraphQL String scalar).
 * Pass the value already serialized with `JSON.stringify(value)`.
 * On read, use `JSON.parse(result)` to recover the original type.
 *
 * Example:
 *   await setPreference('ordersView', JSON.stringify({ layout: 'list' }));
 */

/** @typedef {{ key: string, value?: string | null }} SetPreferenceParams */

const mutationSetPreference = `
  mutation SetPreference($key: String!, $value: String) {
    setPreference(key: $key, value: $value)
  }
`;

export const setPreference = async (/** @type {string} */ key, /** @type {string | null | undefined} */ value) => {
  return gqlRequest(mutationSetPreference, { key, value });
};

export default { setPreference };
